// Central business content — English + Gujarati bilingual snippets
export const BUSINESS = {
  name: "Pravin Hiralal Prajapati",
  tagline: "Wholesale Vegetable Supplier & Commission Agent",
  taglineGu: "જથ્થાબંધ શાકભાજી સપ્લાયર અને કમિશન એજન્ટ",
  location: "E-65, Karnavati Agriculture Market Yard, Vatva, Ahmedabad, Gujarat, India",
  phone: "+91 99250 24675",
  phoneRaw: "+919925024675",
  phone2: "+91 97272 03555",
  phone2Raw: "+919727203555",
  whatsapp: "919925024675",
  email: "info@pravinhiralalprajapati.com",
  hours: [
    { day: "Monday – Saturday", time: "6:00 AM – 7:00 PM" },
    { day: "Sunday", time: "6:00 AM – 1:00 PM" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Karnavati+Agriculture+Market+Yard+Vatva+Ahmedabad&output=embed",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format,compress&w=1920&q=75",
  hands: "https://images.pexels.com/photos/7728868/pexels-photo-7728868.jpeg?auto=compress&cs=tinysrgb&w=800",
  market: "https://images.unsplash.com/photo-1769598249913-9527a1fb151d?auto=format,compress&w=800&q=75",
};

export const PRODUCTS = [
  {
    slug: "capsicum",
    name: "Fresh Capsicum",
    nameGu: "કેપ્સિકમ",
    image: "https://images.pexels.com/photos/2893635/pexels-photo-2893635.jpeg?auto=compress&cs=tinysrgb&w=800",
    blurb: "Crisp, glossy bell peppers graded for colour and firmness.",
    tags: ["Green", "Firm", "Export-grade"],
  },
  {
    slug: "cucumber",
    name: "Fresh Cucumber (Kheera)",
    nameGu: "કાકડી",
    image: "https://images.unsplash.com/photo-1587411768638-ec71f8e33b78?auto=format,compress&w=800&q=75",
    blurb: "Cool, hydrating cucumbers picked young for tender skins.",
    tags: ["Tender", "Daily fresh", "Bulk"],
  },
  {
    slug: "green-peas",
    name: "Fresh Green Peas (Mutter)",
    nameGu: "લીલા વટાણા",
    image: "https://images.pexels.com/photos/32188889/pexels-photo-32188889.jpeg?auto=compress&cs=tinysrgb&w=800",
    blurb: "Sweet, plump peas shelled and sorted at peak season.",
    tags: ["Sweet", "Seasonal", "Sorted"],
  },
  {
    slug: "cabbage",
    name: "Fresh Cabbage",
    nameGu: "કોબીજ",
    image: "https://images.pexels.com/photos/6316537/pexels-photo-6316537.jpeg?auto=compress&cs=tinysrgb&w=800",
    blurb: "Dense, heavy heads with tight leaves and long shelf life.",
    tags: ["Dense", "Long shelf-life", "Retail"],
  },
  {
    slug: "carrot",
    name: "Fresh Carrot",
    nameGu: "ગાજર",
    image: "https://images.unsplash.com/photo-1633380110125-f6e685676160?auto=format,compress&w=800&q=75",
    blurb: "Bright, sweet carrots washed and bunched to order.",
    tags: ["Sweet", "Washed", "Bunched"],
  },
];

export const SERVICES = [
  { n: "01", title: "Wholesale Vegetable Supply", desc: "High-volume, graded produce delivered fresh to your dock every day." },
  { n: "02", title: "Commission Agent Services", desc: "Transparent commission trading connecting growers and buyers fairly." },
  { n: "03", title: "Bulk Vegetable Orders", desc: "Reliable fulfilment for large recurring and one-off bulk requirements." },
  { n: "04", title: "Daily Fresh Stock", desc: "New arrivals sorted at dawn — you always get the freshest lots." },
  { n: "05", title: "Retailer & Distributor Supply", desc: "Consistent grades and pricing to power your resale margins." },
  { n: "06", title: "Hotel & Restaurant Supply", desc: "Chef-grade consistency and dependable timing for kitchens." },
  { n: "07", title: "Exporter Supply", desc: "Export-standard sorting, packing and documentation coordination." },
  { n: "08", title: "Market Rate Assistance", desc: "Live mandi-rate guidance so you buy and sell at the right price." },
  { n: "09", title: "Transparent Trading", desc: "Honest weighing, clear invoicing and no hidden charges — ever." },
  { n: "10", title: "Loading & Transportation", desc: "End-to-end loading and transport coordination to your destination." },
];

export const CUSTOMERS = [
  "Vegetable Wholesalers", "Retail Vegetable Shops", "Supermarkets", "Hotels",
  "Restaurants", "Catering Businesses", "Distributors", "Exporters", "Food Processing Companies",
];

export const WHY = [
  { n: "01", title: "Premium Quality", desc: "Every lot is hand-graded for freshness before it reaches you." },
  { n: "02", title: "Fair Market Prices", desc: "Competitive, transparent pricing anchored to daily mandi rates." },
  { n: "03", title: "Honest Trading", desc: "Accurate weighing and clear accounts you can always trust." },
  { n: "04", title: "Strong Network", desc: "Deep relationships with farmers and buyers across Gujarat." },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Years of Trading" },
  { value: 30, suffix: "+", label: "Tons Supplied Daily" },
  { value: 250, suffix: "+", label: "Partner Farmers" },
  { value: 500, suffix: "+", label: "Business Buyers" },
];

export const TESTIMONIALS = [
  { quote: "The most dependable commission agent in Karnavati. Fresh stock, fair weighing, and always on time for our hotel kitchens.", name: "Rajesh Shah", role: "Purchase Head, Hospitality Group" },
  { quote: "We source cabbage and carrots in bulk weekly. Grades are consistent and the pricing is genuinely transparent.", name: "Meena Patel", role: "Owner, Retail Supermarket" },
  { quote: "Export-standard sorting and reliable loading coordination. Pravinbhai's team understands quality.", name: "Imran Qureshi", role: "Vegetable Exporter" },
];

export const FAQS = [
  { q: "What is the minimum order quantity?", a: "We specialise in wholesale and bulk supply. Minimums vary by product and season — share your requirement via the enquiry form and we'll confirm quickly." },
  { q: "Do you deliver outside Ahmedabad?", a: "Yes. We coordinate loading and transportation to your destination across Gujarat and beyond, including support for exporters." },
  { q: "How are your prices decided?", a: "Prices are anchored to live Karnavati mandi rates with transparent commission — no hidden charges, honest weighing every time." },
  { q: "Which vegetables do you deal in?", a: "Fresh Capsicum, Cucumber (Kheera), Green Peas (Mutter), Cabbage and Carrot, all daily-fresh and quality graded." },
  { q: "How quickly can I get a response?", a: "Submit an enquiry or message us on WhatsApp — our team typically responds the same working day during business hours." },
];
